export const START_TWO_TEAMS_GAME_COMPLETED = "twoTeams/startGameCompleted";
export const GUESS_TWO_TEAMS_DRIVER_COMPLETED = "twoTeams/guessDriverCompleted";
export const GET_TWO_TEAMS_STATUS_COMPLETED = "twoTeams/getGameStatusCompleted";
export const GET_TWO_TEAMS_DRIVER_SUGGESTIONS_COMPLETED = "twoTeams/getDriverSuggestionsCompleted";
export const CLEAR_TWO_TEAMS_DRIVER_SUGGESTIONS = "twoTeams/clearDriverSuggestions";
